import {useEffect, useState} from 'react';
import {AAA002} from "../compte/AAA002"
import {Chargement} from "../compte/Chargement"
import {shuffleArray, disblur} from "../Fonctions"

export function Modal ({auth, setShow_activite}) {
	//console.log(auth)

  	const [tab, setTab] = useState([])
  	const [chargement, setChargement] = useState(true)
  	const [id_question, setId_question] = useState([])
  	let action = auth.action ? auth.action : 'rech_question_simple'


	useEffect(()=>{
		fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
	      method: 'POST',
	      body: JSON.stringify({...auth, action:'rech_question', activite:auth.activite.replace('__2e devoir mêmes notions', '').replace('__3e devoir mêmes notions', ''), notion:auth.notion.filter(e=>!e.includes('mêmes notions'))})
	    })
	    .then(response => response.json())
	    .then(data => {
	    	//console.log('data Modal : ', data)
	      	//return
	    	setChargement(false)
		    let spread_notion = {}
		    auth.notion.forEach(notion=>{
				spread_notion[notion] = []
			})
		    let final_tab = []
			let num = Object.keys(data).filter(e=>e.length)
			//console.log('num : ', num)
			let is_pushed = false

			num.forEach(e => {
				auth.notion.forEach(notion=>{
					if(!notion.includes('/') && data[e][0].includes(notion.split('/')[0]) || notion.includes('/') && data[e][0].includes(notion.split('/')[0]) && data[e][1].toLowerCase().includes(notion.split('/')[1].toLowerCase())){
						
						//vérif si spread_notion contient déjà e
						is_pushed = Object.values(spread_notion).some(tab => tab.some(elt => elt=== e))
						if (!is_pushed){spread_notion[notion].push(e)}
					}
				})
			})
			//console.log('spread_notion : ', spread_notion)
			let num_final = []
			//for (let j=0; j < auth.nb_question/auth.notion.length; j++) {
			for (let j=0; j < 10; j++) {
				for (let i=0; i < auth.notion.length; i++) {
		          if(spread_notion[auth.notion[i]][j]) {num_final.push(spread_notion[auth.notion[i]][j])}
		        }
	        } 
			shuffleArray(num)
			//console.log('num_final : ', num_final)

			shuffleArray(num_final)
			num_final.slice(0,Math.min(auth.nb_question, num.length)).forEach(e => final_tab.push(disblur(data[e])))
			setTab(final_tab)
			setId_question(num_final)
			//console.log('final_tab : ', final_tab)
	      setShow_activite(true)
	    })
	    .catch(err => console.log(err))
    }
  , [])


	//console.log(auth)
	return (
	    <div className='modal active'>
		    <div className="suppr_serie" onClick={()=>{setShow_activite(false)}}></div>
		    {
		    	chargement ? <Chargement />
		    	:
		    	tab.length ? 
		   			<AAA002 auth={auth}/**/ tab={tab} setTab={setTab} setShow_activite={setShow_activite} mode_classe={auth.profil === 'Professeur'} id_question={id_question} />
		    		: 
		    		<div className="mode_classe_content" >
			    		<div className="page" >
					    	<br/><br/><br/>
					    	<div align="center">
					    		Attention<br/>
					    		Pour le niveau choisi, il n'y a pas d'activité pour le moment. <br/>
					    		Veuillez donc choisir un autre niveau...
					    	</div>
						    <br/>
						    <input type="button" className="btn" value="Retour" onClick={()=>{setShow_activite(false)}} />
						    <br/><br/><br/>
					    </div>
				    </div>
		    }
		</div>
  );
}